<div class="editor">

  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>

  <!-- --------------------------------------------------------- CẤU HÌNH CƠ BẢN --------------------------------------------------------- -->
  <ng-container *ngIf="configMode == 'basic'">
    <div>
      <button class="mt-5 w-100" nz-button nzType="primary" (click)="handleEdit()">{{'soan_thao' | translate}}</button>

      <!-- Nội dung khác nhau cho từng thiết bị -->
      <div class="config-name">
        <p>{{'noi_dung_khac_nhau_cho_tung_thiet_bi' | translate}}</p>
        <nz-switch [(ngModel)]="staticdata.is_different_content_for_devices"
          (ngModelChange)="updateStaticData()"></nz-switch>
      </div>

      <!-- Kích thước -->
      <div class="config-name mb-4">
        <p>{{'kich_thuoc_chu' | translate}}</p>
        <nz-input-number [nzMin]="1" [nzMax]="100" [ngModel]="class['text-paragraph__editor']['font-size'] | vhnumber"
          (ngModelChange)="class['text-paragraph__editor']['font-size'] = $event +'px'" (nzBlur)="updateClass()">
        </nz-input-number>
      </div>

      <!-- Khoảng cách dòng -->
      <div class="mb-4">
        <div class="config-name">
          <p>{{'khoang_cach_dong' | translate}}</p>
          <nz-input-number [nzMin]="0.1" [nzMax]="5" [nzStep]="0.1"
            [(ngModel)]="class['text-paragraph__editor']['line-height']" (nzBlur)="updateClass()">
          </nz-input-number>
        </div>
        <div>
          <nz-slider [nzMin]="0.1" [nzMax]="5" [nzStep]="0.1"
            [(ngModel)]="class['text-paragraph__editor']['line-height']" (nzOnAfterChange)="updateClass()">
          </nz-slider>
        </div>
      </div>

      <!-- Kiểu hiển thị -->
      <div class="mt-3">
        <p class="mb-1">{{'kieu_hien_thi' | translate}}</p>
        <nz-select [(ngModel)]="class['text-paragraph']['overflow-y']" (ngModelChange)="updateClass()">
          <nz-option nzValue="visible" nzLabel="Dãn"></nz-option>
          <nz-option nzValue="auto" nzLabel="Cuộn"></nz-option>
          <nz-option nzValue="hidden" nzLabel="Cố định"></nz-option>
        </nz-select>
      </div>
    </div>
  </ng-container>


  <!-- -------------------------------------------------------- CẤU HÌNH NÂNG CAO -------------------------------------------------------- -->
  <ng-container *ngIf="configMode == 'advanced'">
    <!-- Hiển thị tiêu đề mở rộng -->
    <div class="editor-header" *ngIf="isViewAll">
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
    </div>

    <ng-container *ngIf="!isViewAll">
      <div class="text-paragraph-config">
        <!-- Nội dung khác nhau cho từng thiết bị -->
        <div class="config-name">
          <p>{{'noi_dung_khac_nhau_cho_tung_thiet_bi' | translate}}</p>
          <nz-switch [(ngModel)]="staticdata.is_different_content_for_devices"
            (ngModelChange)="updateStaticData()"></nz-switch>
        </div>

        <!-- Kích thước -->
        <div class="config-name mb-4">
          <p>{{'kich_thuoc_chu' | translate}}</p>
          <nz-input-number [nzMin]="1" [nzMax]="100" [ngModel]="class['text-paragraph__editor']['font-size'] | vhnumber"
            (ngModelChange)="class['text-paragraph__editor']['font-size'] = $event +'px'" (nzBlur)="updateClass()">
          </nz-input-number>
        </div>

        <!-- Khoảng cách dòng -->
        <div class="mb-4">
          <div class="config-name">
            <p>{{'khoang_cach_dong' | translate}}</p>
            <nz-input-number [nzMin]="0.1" [nzMax]="5" [nzStep]="0.1"
              [(ngModel)]="class['text-paragraph__editor']['line-height']" (nzBlur)="updateClass()">
            </nz-input-number>
          </div>
          <div>
            <nz-slider [nzMin]="0.1" [nzMax]="5" [nzStep]="0.1"
              [(ngModel)]="class['text-paragraph__editor']['line-height']" (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
        </div>

        <!-- Kiểu hiển thị -->
        <div class="mt-3">
          <p class="mb-1">{{'kieu_hien_thi' | translate}}</p>
          <nz-select [(ngModel)]="class['text-paragraph']['overflow-y']" (ngModelChange)="updateClass()">
            <nz-option nzValue="visible" nzLabel="Dãn"></nz-option>
            <nz-option nzValue="auto" nzLabel="Cuộn"></nz-option>
            <nz-option nzValue="hidden" nzLabel="Cố định"></nz-option>
          </nz-select>
        </div>

        <!-- Cấu hình thanh cuộn -->
        <ng-container *ngIf="class['text-paragraph']['overflow-y'] == 'auto'">
          <!-- Độ rộng thanh cuộn -->
          <div>
            <div class="config-name">
              <p>{{'do_rong_thanh_cuon' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" [ngModel]="config['-webkit-scrollbar']['width'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['width'] = $event +'px'" (nzBlur)="updateConfig()">
              </nz-input-number>
            </div>
            <div>
              <nz-slider [nzMin]="1" [nzMax]="100" [ngModel]="config['-webkit-scrollbar']['width'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['width'] = $event +'px'" (nzOnAfterChange)="updateConfig()">
              </nz-slider>
            </div>
          </div>
          <!-- Bo góc thanh cuộn -->
          <div>
            <div class="config-name">
              <p>{{'bo_goc_thanh_cuon' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100"
                [ngModel]="config['-webkit-scrollbar']['border-radius'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['border-radius'] = $event +'px'" (nzBlur)="updateConfig()">
              </nz-input-number>
            </div>
            <div>
              <nz-slider [nzMin]="1" [nzMax]="100" [ngModel]="config['-webkit-scrollbar']['border-radius'] | vhnumber"
                (ngModelChange)="config['-webkit-scrollbar']['border-radius'] = $event +'px'"
                (nzOnAfterChange)="updateConfig()">
              </nz-slider>
            </div>
          </div>
          <!-- Màu nền thanh cuộn -->
          <div class="config-name mt-4">
            <p>{{'mau_nen_thanh_cuon' | translate}}</p>
            <div>
              <input class="input-color" type="button" [cpOKButton]="true"
                [style.background]="config['-webkit-scrollbar']['background-color']"
                [(colorPicker)]="config['-webkit-scrollbar']['background-color']" (colorPickerClose)="updateConfig()" />
            </div>
          </div>
          <!-- Màu thanh cuộn -->
          <div class="config-name mt-4">
            <p>{{'mau_thanh_keo' | translate}}</p>
            <div>
              <input class="input-color" type="button" [cpOKButton]="true"
                [style.background]="config['-webkit-scrollbar']['thumb-background-color']"
                [(colorPicker)]="config['-webkit-scrollbar']['thumb-background-color']"
                (colorPickerClose)="updateConfig()" />
            </div>
          </div>

        </ng-container>

        <button class="mt-5 w-100" nz-button nzType="primary" (click)="handleEdit()">{{'soan_thao' | translate}}</button>

        <!-- HIỆU ỨNG -->
        <div class="config-name flex-wrap mt-4">
          <p>{{'hieu_ung' | translate}}</p>
          <app-choose-animations-config [elementChoosing]="objectChoosing" [id_object]="objectChoosing._id"
            [device]="device" [class]="class" [config]="config" [staticdata]="staticdata" [cursorClass]="class['text-paragraph__editor']"
            [effect_hover]="effect_hover" [customize]="customize" (openAnimationDetail)="openAnimationDetail($event)"
            [effectFileUsing]="'short-description'">
          </app-choose-animations-config>
        </div>
      </div>
    </ng-container>

    <!-- Xem chi tiết cấu hình object -->
    <div class="view-more" *ngIf="isViewAll">
      <!-- Cấu hình chi tiết hiệu ứng -->
      <div class="editor_effect-hover" *ngIf="config['animation-selected'].id != '000000' && currentViewAll.index == 1">
        <app-animations-config [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata"
          [id_object]="objectChoosing._id" [customize]="customize"></app-animations-config>
      </div>
    </div>
  </ng-container>
</div>